import { render, staticRenderFns } from "./pdm_ranges.vue?vue&type=template&id=f442d4d0"
import script from "./pdm_ranges.vue?vue&type=script&lang=js"
export * from "./pdm_ranges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports